(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4321],{

/***/ 83083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m5 7.5 5 5 5-5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgDown);

/***/ }),

/***/ 53938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useComposedRefs; }
/* harmony export */ });
/* unused harmony export assignRef */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _type_check__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11206);


/**
 * Passes or assigns an arbitrary value to a ref function or object.
 *
 * @param ref
 * @param value
 */ function assignRef(ref, value) {
    if (ref == null) return;
    if ((0,_type_check__WEBPACK_IMPORTED_MODULE_1__/* .isFunction */ .mf)(ref)) {
        ref(value);
    } else {
        try {
            ref.current = value;
        } catch (error) {
            throw new Error('Cannot assign value "'.concat(value, '" to ref "').concat(ref, '"'));
        }
    }
}
/**
 * Passes or assigns a value to multiple refs (typically a DOM node). Useful for
 * dealing with components that need an explicit ref for DOM calculations but
 * also forwards refs assigned by an app.
 *
 * @param refs Refs to fork
 */ function useComposedRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((node)=>{
        for (let ref of refs){
            assignRef(ref, node);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


/***/ }),

/***/ 62046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ noop; }
/* harmony export */ });
function noop() {}


/***/ }),

/***/ 11206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; }
/* harmony export */ });
/* unused harmony exports isBoolean, isNumber */
/**
 * Checks whether or not a value is a boolean.
 *
 * @param value
 */ function isBoolean(value) {
    return typeof value === "boolean";
}
/**
 * Checks whether or not a value is a function.
 *
 * @param value
 */ function isFunction(value) {
    // eslint-disable-next-line eqeqeq
    return !!(value && ({}).toString.call(value) == "[object Function]");
}
/**
 * Checks whether or not a value is a number.
 *
 * @param value
 */ function isNumber(value) {
    return typeof value === "number" && !isNaN(value);
}
/**
 * Checks whether or not a value is a string.
 *
 * @param value
 */ function isString(value) {
    return typeof value === "string";
}


/***/ }),

/***/ 41176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useHandleResize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useHandleResize = ()=>{
    const [width, setWidth] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const handleResize = async ()=>{
        setWidth(window.innerWidth);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return width;
};


/***/ }),

/***/ 55353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useKeyDown; },
/* harmony export */   "e": function() { return /* binding */ KeyName; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const KeyName = {
    ESC: [
        "Escape",
        "Esc"
    ],
    Enter: [
        "Enter"
    ]
};
const useKeyDown = (id, handler)=>{
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(()=>{
        const keys = [
            id
        ].flat(Infinity);
        const handle = (e)=>{
            if (keys.includes(e.key)) handler === null || handler === void 0 ? void 0 : handler(e);
        };
        document.addEventListener("keydown", handle);
        return ()=>document.removeEventListener("keydown", handle);
    }, [
        id,
        handler
    ]);
};


/***/ }),

/***/ 6547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Drawer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _drawer_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91028);
/* harmony import */ var _drawer_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_drawer_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Drawer = (props)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (props.show) {
            var _ref_current;
            if (!((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.open)) {
                var _ref_current1;
                (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.showModal();
            }
        } else {
            var _ref_current2;
            if ((_ref_current2 = ref.current) === null || _ref_current2 === void 0 ? void 0 : _ref_current2.open) {
                var _ref_current3;
                (_ref_current3 = ref.current) === null || _ref_current3 === void 0 ? void 0 : _ref_current3.close();
            }
        }
    }, [
        props.show
    ]);
    const onClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((e)=>{
        if (e.target === ref.current) props.onDismiss();
    }, [
        ref,
        props.onDismiss
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dialog", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_drawer_module_scss__WEBPACK_IMPORTED_MODULE_3___default().drawer), props.show && (_drawer_module_scss__WEBPACK_IMPORTED_MODULE_3___default().show), props.className),
        style: props.style,
        id: props.htmlId,
        ref: ref,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_drawer_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inner),
            children: props.children
        })
    });
};
Drawer.defaultProps = {};


/***/ }),

/***/ 99088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _input_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5915);
/* harmony import */ var _input_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_input_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref)=>{
    const innerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, ()=>innerRef.current);
    const { value , size , className , style , id , prefix , suffix , prefixStyling , suffixStyling , ...restProps } = props;
    const [focus, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const canInlineSuffix = !props.noInlineSuffix && props.readOnly && props.suffix && typeof props.suffix === "string" && !props.suffixStyling;
    const onClick = ()=>{
        var _innerRef_current;
        (_innerRef_current = innerRef.current) === null || _innerRef_current === void 0 ? void 0 : _innerRef_current.focus();
    };
    const onFocus = (e)=>{
        var _props_onFocus;
        setFocus(true);
        (_props_onFocus = props.onFocus) === null || _props_onFocus === void 0 ? void 0 : _props_onFocus.call(props, e);
    };
    const onBlur = (e)=>{
        var _props_onBlur;
        setFocus(false);
        (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 ? void 0 : _props_onBlur.call(props, e);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().input), size === "small" && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().small), size === "medium" && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().medium), size === "large" && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().large), prefix && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().with_prefix), suffix && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().with_suffix), !prefixStyling && prefix && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().no_prefix_styling), !suffixStyling && suffix && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().no_suffix_styling), focus && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().focus), props.readOnly && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().readonly), className),
        onClick: onClick,
        style: style,
        id: id,
        children: [
            prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().prefix), !prefixStyling && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().no_styling)),
                children: prefix
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "text",
                value: canInlineSuffix ? "".concat(value || "", " ").concat(suffix) : value,
                ...restProps,
                onFocus: onFocus,
                onBlur: onBlur,
                ref: innerRef
            }),
            suffix && !canInlineSuffix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().suffix), !suffixStyling && (_input_module_scss__WEBPACK_IMPORTED_MODULE_3___default().no_styling)),
                children: suffix
            })
        ]
    });
});
Input.defaultProps = {
    prefixStyling: true,
    suffixStyling: true
};


/***/ }),

/***/ 92400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mr": function() { return /* binding */ CLOSE_MENU; },
  "KG": function() { return /* binding */ DropdownProvider_; },
  "tv": function() { return /* binding */ useDropdownContext; },
  "FG": function() { return /* binding */ useDropdownItem; },
  "eV": function() { return /* binding */ useDropdownItems; },
  "ED": function() { return /* binding */ useDropdownPopover; },
  "MK": function() { return /* binding */ useDropdownTrigger; }
});

// UNUSED EXPORTS: DropdownItem, DropdownItems, DropdownTrigger, useDropdownDescendants

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
;// CONCATENATED MODULE: ./src/shared/lib/context.tsx


/** @deprecated */ function createNamedContext(name, defaultValue) {
    let Ctx = /*#__PURE__*/ React.createContext(defaultValue);
    Ctx.displayName = name;
    return Ctx;
}
function createContext(rootComponentName, defaultContext) {
    let Ctx = /*#__PURE__*/ react.createContext(defaultContext);
    function Provider(props) {
        let { children , ...context } = props;
        let value = react.useMemo(()=>context, // eslint-disable-next-line react-hooks/exhaustive-deps
        Object.values(context));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Ctx.Provider, {
            value: value,
            children: children
        });
    }
    function useContext(callerComponentName) {
        let context = react.useContext(Ctx);
        if (context) {
            return context;
        }
        if (defaultContext) {
            return defaultContext;
        }
        throw Error("".concat(callerComponentName, " must be rendered inside of a ").concat(rootComponentName, " component."));
    }
    Ctx.displayName = "".concat(rootComponentName, "Context");
    Provider.displayName = "".concat(rootComponentName, "Provider");
    return [
        Provider,
        useContext
    ];
}

;// CONCATENATED MODULE: ./src/shared/lib/make-id.ts
/**
 * Joins strings to format IDs for compound components.
 *
 * @param args
 */ function makeId() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.filter((val)=>val != null).join("--");
}

// EXTERNAL MODULE: ./src/shared/lib/type-check.ts
var type_check = __webpack_require__(11206);
// EXTERNAL MODULE: ./src/shared/lib/compose-refs.ts
var compose_refs = __webpack_require__(53938);
;// CONCATENATED MODULE: ./src/shared/lib/is-right-click.ts
/**
 * Detects right clicks
 *
 * @param nativeEvent
 */ function isRightClick(nativeEvent) {
    return "which" in nativeEvent ? nativeEvent.which === 3 : "button" in nativeEvent ? nativeEvent.button === 2 : false;
}

;// CONCATENATED MODULE: ./src/shared/lib/compose-event-handlers.ts
/**
 * Wraps a lib-defined event handler and a user-defined event handler, returning
 * a single handler that allows a user to prevent lib-defined handlers from
 * firing.
 *
 * @param theirHandler User-supplied event handler
 * @param ourHandler Library-supplied event handler
 */ function composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) {
            return ourHandler(event);
        }
    };
}

;// CONCATENATED MODULE: ./src/shared/lib/use-stateful-ref-value.ts

function useStatefulRefValue(ref, initialState) {
    let [state, setState] = (0,react.useState)(initialState);
    let callbackRef = (0,react.useCallback)((refValue)=>{
        ref.current = refValue;
        setState(refValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        state,
        callbackRef
    ];
}

// EXTERNAL MODULE: ./src/shared/lib/can-use-dom.ts
var can_use_dom = __webpack_require__(29359);
;// CONCATENATED MODULE: ./src/shared/lib/owner-document.ts

/**
 * Get an element's owner document. Useful when components are used in iframes
 * or other environments like dev tools.
 *
 * @param element
 */ function getOwnerDocument(element) {
    return (0,can_use_dom/* canUseDOM */.N)() ? element ? element.ownerDocument : document : null;
}
/**
 * TODO: Remove in 1.0
 */ function getOwnerWindow(element) {
    let ownerDocument = getOwnerDocument(element);
    return ownerDocument ? ownerDocument.defaultView || window : null;
}

;// CONCATENATED MODULE: ./src/shared/lib/use-previous.ts

/**
 * Returns the previous value of a reference after a component update.
 *
 * @param value
 */ function usePrevious(value) {
    const ref = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

// EXTERNAL MODULE: ./src/shared/lib/use-isomorphic-layout-effect.ts
var use_isomorphic_layout_effect = __webpack_require__(3403);
;// CONCATENATED MODULE: ./src/shared/ui/menu/lib/auto-id.ts
/*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */ /* eslint-disable react-hooks/rules-of-hooks */ 

let serverHandoffComplete = false;
let id = 0;
function genId() {
    return ++id;
}
// Workaround for https://github.com/webpack/webpack/issues/14814
// https://github.com/eps1lon/material-ui/blob/8d5f135b4d7a58253a99ab56dce4ac8de61f5dc1/packages/mui-utils/src/useId.ts#L21
const maybeReactUseId = react_namespaceObject["useId".toString()];
function useId(providedId) {
    if (maybeReactUseId !== undefined) {
        let generatedId = maybeReactUseId();
        return providedId !== null && providedId !== void 0 ? providedId : generatedId;
    }
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    let initialId = providedId !== null && providedId !== void 0 ? providedId : serverHandoffComplete ? genId() : null;
    let [id, setId] = react.useState(initialId);
    (0,use_isomorphic_layout_effect/* useIsomorphicLayoutEffect */.L)(()=>{
        if (id === null) {
            // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
            // rendering flicker, though it'll make the first render slower (unlikely
            // to matter, but you're welcome to measure your app and let us know if
            // it's a problem).
            setId(genId());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react.useEffect(()=>{
        if (serverHandoffComplete === false) {
            // Flag all future uses of `useId` to skip the update dance. This is in
            // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
            // accidentally bail out of the patch-up dance prematurely.
            serverHandoffComplete = true;
        }
    }, []);
    var _ref;
    return (_ref = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _ref !== void 0 ? _ref : undefined;
}


// EXTERNAL MODULE: ./src/shared/lib/noop.ts
var noop = __webpack_require__(62046);
// EXTERNAL MODULE: ./src/shared/lib/use-force-update.ts
var use_force_update = __webpack_require__(17205);
;// CONCATENATED MODULE: ./src/shared/ui/menu/lib/descendants.tsx



const __DEV__ = "production" === "development";
function createDescendantContext(name) {
    let initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const descendants = [];
    let ctx = /*#__PURE__*/ react.createContext({
        descendants,
        registerDescendant: ()=>noop/* noop */.Z,
        ...initialValue
    });
    ctx.displayName = name;
    return ctx;
}
/**
 * This hook registers our descendant by passing it into an array. We can then
 * search that array by to find its index when registering it in the component.
 * We use this for focus management, keyboard navigation, and typeahead
 * functionality for some components.
 *
 * The hook accepts the element node and (optionally) a key. The key is useful
 * if multiple descendants have identical text values and we need to
 * differentiate siblings for some reason.
 *
 * Our main goals with this are:
 *   1) maximum composability,
 *   2) minimal API friction
 *   3) SSR compatibility*
 *   4) concurrent safe
 *   5) index always up-to-date with the tree despite changes
 *   6) works with memoization of any component in the tree (hopefully)
 *
 * As for SSR, the good news is that we don't actually need the index on the
 * server for most use-cases, as we are only using it to determine the order of
 * composed descendants for keyboard navigation. However, in the few cases where
 * this is not the case, we can require an explicit index from the app.
 */ function useDescendant(descendant, context, indexProp) {
    let forceUpdate = (0,use_force_update/* useForceUpdate */.N)();
    let { registerDescendant , descendants  } = react.useContext(context);
    // This will initially return -1 because we haven't registered the descendant
    // on the first render. After we register, this will then return the correct
    // index on the following render and we will re-register descendants so that
    // everything is up-to-date before the user interacts with a collection.
    let index = indexProp !== null && indexProp !== void 0 ? indexProp : descendants.findIndex((item)=>item.element === descendant.element);
    // Prevent any flashing
    (0,use_isomorphic_layout_effect/* useIsomorphicLayoutEffect */.L)(()=>{
        if (!descendant.element) forceUpdate();
        return registerDescendant({
            ...descendant,
            index
        });
    }, [
        descendant,
        forceUpdate,
        index,
        registerDescendant,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.values(descendant)
    ]);
    return index;
}
function useDescendantsInit() {
    return react.useState([]);
}
function useDescendants(ctx) {
    return react.useContext(ctx).descendants;
}
function DescendantProvider(param) {
    let { context: Ctx , children , items , set  } = param;
    let registerDescendant = react.useCallback((param)=>{
        let { element , index: explicitIndex , ...rest } = param;
        if (!element) return noop/* noop */.Z;
        set((items)=>{
            if (explicitIndex != null && explicitIndex !== -1) {
                return insertAt(items, {
                    element,
                    index: explicitIndex,
                    ...rest
                }, explicitIndex);
            }
            if (items.length === 0) {
                // If there are no items, register at index 0 and bail.
                return [
                    {
                        ...rest,
                        element,
                        index: 0
                    }
                ];
            }
            if (__DEV__) {
                if (items.find((item)=>item.element === element)) {
                    console.warn("[reach-ui]: `useDescendant` was called with an element that was " + "already registered.\n\n" + "If you are using the `@reach/descendants` package directly, " + "make sure to only register descendants once. Registering a descendant " + "more than once will lead to bugs in your app.\n\n" + "If you are using another `reach-ui` package, this is probably our bug!\n\n" + "To report a bug, open a new issue:\n\n" + "  https://github.com/reach/reach-ui/issues/new?assignees=&labels=&template=Bug_report.md\n\n" + "IMPORTANT: this check will only run in the development build, so if you " + "see this warning please be aware that your app may crash when deployed.");
                    return updateIndices(items);
                }
            }
            let index = findDOMIndex(items, element);
            let newItems;
            if (index === -1) {
                newItems = [
                    ...items,
                    {
                        ...rest,
                        element,
                        index: items.length
                    }
                ];
            } else {
                newItems = insertAt(items, {
                    ...rest,
                    element,
                    index
                }, index);
            }
            return newItems;
        });
        return ()=>{
            if (!element) return;
            set((items)=>items.filter((item)=>element !== item.element));
        };
    }, // set is a state setter initialized by the useDescendantsInit hook.
    // We can safely ignore the lint warning here because it will not change
    // between renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Ctx.Provider, {
        value: react.useMemo(()=>{
            return {
                descendants: items,
                registerDescendant
            };
        }, [
            items,
            registerDescendant
        ]),
        children: children
    });
}
/**
 * Testing this as an abstraction for compound components that use keyboard
 * navigation. Hoping this will help us prevent bugs and mismatched behavior
 * across various components, but it may also prove to be too messy of an
 * abstraction in the end.
 *
 * Currently used in:
 *   - Tabs
 *   - Accordion
 *
 * @param context
 * @param options
 */ function useDescendantKeyDown(context, options) {
    let { descendants  } = react.useContext(context);
    let { callback , currentIndex , filter , key ="index" , orientation ="vertical" , rotate =true , rtl =false  } = options;
    return function handleKeyDown(event) {
        if (![
            "ArrowDown",
            "ArrowUp",
            "ArrowLeft",
            "ArrowRight",
            "PageUp",
            "PageDown",
            "Home",
            "End"
        ].includes(event.key)) {
            return;
        }
        let index = currentIndex !== null && currentIndex !== void 0 ? currentIndex : -1;
        // If we use a filter function, we need to re-index our descendants array
        // so that filtered descendent elements aren't selected.
        let selectableDescendants = filter ? descendants.filter(filter) : descendants;
        // We need some options for any of this to work!
        if (!selectableDescendants.length) {
            return;
        }
        let selectableIndex = selectableDescendants.findIndex((descendant)=>descendant.index === currentIndex);
        function getNextOption() {
            let atBottom = index === getLastOption().index;
            return atBottom ? rotate ? getFirstOption() : selectableDescendants[selectableIndex] : selectableDescendants[(selectableIndex + 1) % selectableDescendants.length];
        }
        function getPreviousOption() {
            let atTop = index === getFirstOption().index;
            return atTop ? rotate ? getLastOption() : selectableDescendants[selectableIndex] : selectableDescendants[(selectableIndex - 1 + selectableDescendants.length) % selectableDescendants.length];
        }
        function getFirstOption() {
            return selectableDescendants[0];
        }
        function getLastOption() {
            return selectableDescendants[selectableDescendants.length - 1];
        }
        switch(event.key){
            case "ArrowDown":
                if (orientation === "vertical" || orientation === "both") {
                    event.preventDefault();
                    let next = getNextOption();
                    callback(key === "option" ? next : next[key]);
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical" || orientation === "both") {
                    event.preventDefault();
                    let prev = getPreviousOption();
                    callback(key === "option" ? prev : prev[key]);
                }
                break;
            case "ArrowLeft":
                if (orientation === "horizontal" || orientation === "both") {
                    event.preventDefault();
                    let nextOrPrev = (rtl ? getNextOption : getPreviousOption)();
                    callback(key === "option" ? nextOrPrev : nextOrPrev[key]);
                }
                break;
            case "ArrowRight":
                if (orientation === "horizontal" || orientation === "both") {
                    event.preventDefault();
                    let prevOrNext = (rtl ? getPreviousOption : getNextOption)();
                    callback(key === "option" ? prevOrNext : prevOrNext[key]);
                }
                break;
            case "PageUp":
                event.preventDefault();
                let prevOrFirst = (event.ctrlKey ? getPreviousOption : getFirstOption)();
                callback(key === "option" ? prevOrFirst : prevOrFirst[key]);
                break;
            case "Home":
                event.preventDefault();
                let first = getFirstOption();
                callback(key === "option" ? first : first[key]);
                break;
            case "PageDown":
                event.preventDefault();
                let nextOrLast = (event.ctrlKey ? getNextOption : getLastOption)();
                callback(key === "option" ? nextOrLast : nextOrLast[key]);
                break;
            case "End":
                event.preventDefault();
                let last = getLastOption();
                callback(key === "option" ? last : last[key]);
                break;
        }
    };
}
function isElementPreceding(a, b) {
    return Boolean(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function findDOMIndex(items, element) {
    if (!element) return -1;
    if (!items.length) return -1;
    let length = items.length;
    // Most of the times, the new item will be added at the end of the list, so we
    // do a findeIndex in reverse order, instead of wasting time searching the
    // index from the beginning.
    while(length--){
        let currentElement = items[length].element;
        if (!currentElement) continue;
        if (isElementPreceding(currentElement, element)) {
            return length + 1;
        }
    }
    return -1;
}
/**
 * Copy an array of items with a new item added at a specific index.
 * @param array The source array
 * @param item The item to insert into the array
 * @param index The index to insert the item at
 * @returns A copy of the array with the item inserted at the specified index
 */ function insertAt(array, item, index) {
    if (index == null || !(index in array)) {
        return [
            ...array,
            item
        ];
    }
    return [
        ...array.slice(0, index),
        item,
        ...array.slice(index)
    ];
}
function updateIndices(items) {
    return items.sort((a, b)=>!a.element || !b.element ? 0 : isElementPreceding(a.element, b.element) ? -1 : 1).map((item, index)=>({
            ...item,
            index
        }));
}


;// CONCATENATED MODULE: ./src/shared/ui/menu/lib/dropdown.tsx






////////////////////////////////////////////////////////////////////////////////
// Actions
const CLEAR_SELECTION_INDEX = "CLEAR_SELECTION_INDEX";
const CLICK_MENU_ITEM = "CLICK_MENU_ITEM";
const CLOSE_MENU = "CLOSE_MENU";
const OPEN_MENU_AT_FIRST_ITEM = "OPEN_MENU_AT_FIRST_ITEM";
const OPEN_MENU_AT_INDEX = "OPEN_MENU_AT_INDEX";
const OPEN_MENU_CLEARED = "OPEN_MENU_CLEARED";
const SEARCH_FOR_ITEM = "SEARCH_FOR_ITEM";
const SELECT_ITEM_AT_INDEX = "SELECT_ITEM_AT_INDEX";
const SET_BUTTON_ID = "SET_BUTTON_ID";
const DropdownDescendantContext = createDescendantContext("DropdownDescendantContext");
const [DropdownProvider, useDropdownContext] = createContext("Dropdown");
const initialState = {
    // The button ID is needed for aria controls and can be set directly and
    // updated for top-level use via context. Otherwise a default is set by useId.
    // TODO: Consider deprecating direct ID in 1.0 in favor of id at the top level
    //       for passing deterministic IDs to descendent components.
    triggerId: null,
    // Whether or not the dropdown is expanded
    isExpanded: false,
    // When a user begins typing a character string, the selection will change if
    // a matching item is found
    typeaheadQuery: "",
    // The index of the current selected item. When the selection is cleared a
    // value of -1 is used.
    selectionIndex: -1
};
////////////////////////////////////////////////////////////////////////////////
// Dropdown!
const DropdownProvider_ = (param)=>{
    let { id , children , placement  } = param;
    let triggerRef = react.useRef(null);
    let dropdownRef = react.useRef(null);
    let popoverRef = react.useRef(null);
    const [referenceElement, setReferenceElement] = (0,react.useState)(null);
    let [descendants, setDescendants] = useDescendantsInit();
    let _id = useId(id);
    let dropdownId = id || makeId("menu", _id);
    let triggerId = makeId("menu-button", dropdownId);
    let [state, dispatch] = react.useReducer(reducer, {
        ...initialState,
        triggerId
    });
    // We use an event listener attached to the window to capture outside clicks
    // that close the dropdown. We don't want the initial button click to trigger
    // this when a dropdown is closed, so we can track this behavior in a ref for
    // now. We shouldn't need this when we rewrite with state machine logic.
    let triggerClickedRef = react.useRef(false);
    // We will put children callbacks in a ref to avoid triggering endless render
    // loops when using render props if the app code doesn't useCallback
    // https://github.com/reach/reach-ui/issues/523
    let selectCallbacks = react.useRef([]);
    // If the popover's position overlaps with an option when the popover
    // initially opens, the mouseup event will trigger a select. To prevent that,
    // we decide the control is only ready to make a selection if the pointer
    // moves a certain distance OR if the mouse button is pressed for a certain
    // length of time, otherwise the user is just registering the initial button
    // click rather than selecting an item.
    // For context on some implementation details, see https://github.com/reach/reach-ui/issues/563
    let readyToSelect = react.useRef(false);
    let mouseDownStartPosRef = react.useRef({
        x: 0,
        y: 0
    });
    // When the dropdown is open, focus is placed on the dropdown itself so that
    // keyboard navigation is still possible.
    react.useEffect(()=>{
        if (state.isExpanded) {
            // @ts-ignore
            window.__REACH_DISABLE_TOOLTIPS = true;
            window.requestAnimationFrame(()=>{
                dropdown_focus(dropdownRef.current);
            });
        } else {
            // We want to ignore the immediate focus of a tooltip so it doesn't pop up
            // again when the dropdown closes, only pops up when focus returns again
            // to the tooltip (like native OS tooltips).
            // @ts-ignore
            window.__REACH_DISABLE_TOOLTIPS = false;
        }
    }, [
        state.isExpanded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DescendantProvider, {
        context: DropdownDescendantContext,
        items: descendants,
        set: setDescendants,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownProvider, {
            dispatch: dispatch,
            dropdownId: dropdownId,
            dropdownRef: dropdownRef,
            mouseDownStartPosRef: mouseDownStartPosRef,
            popoverRef: popoverRef,
            readyToSelect: readyToSelect,
            selectCallbacks: selectCallbacks,
            state: state,
            triggerClickedRef: triggerClickedRef,
            triggerRef: triggerRef,
            referenceElement: referenceElement,
            setReferenceElement: setReferenceElement,
            placement: placement,
            children: (0,type_check/* isFunction */.mf)(children) ? children({
                isExpanded: state.isExpanded,
                // TODO: Remove in 1.0
                isOpen: state.isExpanded
            }) : children
        })
    });
};
DropdownProvider_.displayName = "DropdownProvider";
////////////////////////////////////////////////////////////////////////////////
function useDropdownTrigger(param) {
    let { onKeyDown , onMouseDown , id , ref: forwardedRef , ...props } = param;
    let { dispatch , dropdownId , mouseDownStartPosRef , triggerClickedRef , triggerRef , state: { triggerId , isExpanded  } , setReferenceElement  } = useDropdownContext("useDropdownTrigger");
    let ref = (0,compose_refs/* useComposedRefs */.e)(triggerRef, forwardedRef, setReferenceElement);
    let items = useDropdownDescendants();
    let firstNonDisabledIndex = react.useMemo(()=>items.findIndex((item)=>!item.disabled), [
        items
    ]);
    react.useEffect(()=>{
        if (id != null && id !== triggerId) {
            dispatch({
                type: SET_BUTTON_ID,
                payload: id
            });
        }
    }, [
        triggerId,
        dispatch,
        id
    ]);
    react.useEffect(()=>{
        if (id == null) {
            dispatch({
                type: SET_BUTTON_ID,
                payload: makeId("menu-button", dropdownId)
            });
        }
    }, [
        dropdownId,
        dispatch,
        id
    ]);
    function handleKeyDown(event) {
        switch(event.key){
            case "ArrowDown":
            case "ArrowUp":
                event.preventDefault(); // prevent scroll
                dispatch({
                    type: OPEN_MENU_AT_INDEX,
                    payload: {
                        index: firstNonDisabledIndex
                    }
                });
                break;
            case "Enter":
            case " ":
                dispatch({
                    type: OPEN_MENU_AT_INDEX,
                    payload: {
                        index: firstNonDisabledIndex
                    }
                });
                break;
            default:
                break;
        }
    }
    function handleMouseDown(event) {
        if (isRightClick(event.nativeEvent)) {
            return;
        }
        mouseDownStartPosRef.current = {
            x: event.clientX,
            y: event.clientY
        };
        if (!isExpanded) {
            triggerClickedRef.current = true;
        }
        if (isExpanded) {
            dispatch({
                type: CLOSE_MENU
            });
        } else {
            dispatch({
                type: OPEN_MENU_CLEARED
            });
        }
    }
    return {
        data: {
            isExpanded,
            controls: dropdownId
        },
        props: {
            ...props,
            ref,
            id: triggerId || undefined,
            onKeyDown: composeEventHandlers(onKeyDown, handleKeyDown),
            onMouseDown: composeEventHandlers(onMouseDown, handleMouseDown),
            type: "button"
        }
    };
}
const DropdownTrigger = /*#__PURE__*/ react.forwardRef((param, forwardedRef)=>{
    let { as: Comp = "button" , ...rest } = param;
    let { props  } = useDropdownTrigger({
        ...rest,
        ref: forwardedRef
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comp, {
        "data-reach-dropdown-trigger": "",
        ...props
    });
});
DropdownTrigger.displayName = "DropdownTrigger";
////////////////////////////////////////////////////////////////////////////////
function useDropdownItem(param) {
    let { index: indexProp , isLink =false , onClick , onDragStart , onMouseDown , onMouseEnter , onMouseLeave , onMouseMove , onMouseUp , onSelect , disabled , onFocus , valueText: valueTextProp , ref: forwardedRef , ...props } = param;
    let { dispatch , dropdownRef , mouseDownStartPosRef , readyToSelect , selectCallbacks , triggerRef , state: { selectionIndex , isExpanded  }  } = useDropdownContext("useDropdownItem");
    let ownRef = react.useRef(null);
    // After the ref is mounted to the DOM node, we check to see if we have an
    // explicit valueText prop before looking for the node's textContent for
    // typeahead functionality.
    let [valueText, setValueText] = react.useState(valueTextProp || "");
    let setValueTextFromDOM = react.useCallback((node)=>{
        if (!valueTextProp && (node === null || node === void 0 ? void 0 : node.textContent)) {
            setValueText(node.textContent);
        }
    }, [
        valueTextProp
    ]);
    let mouseEventStarted = react.useRef(false);
    let [element, handleRefSet] = useStatefulRefValue(ownRef, null);
    let descendant = react.useMemo(()=>{
        return {
            element,
            key: valueText,
            disabled,
            isLink
        };
    }, [
        disabled,
        element,
        isLink,
        valueText
    ]);
    let index = useDescendant(descendant, DropdownDescendantContext, indexProp);
    let isSelected = index === selectionIndex && !disabled;
    let ref = (0,compose_refs/* useComposedRefs */.e)(forwardedRef, handleRefSet, setValueTextFromDOM);
    // Update the callback ref array on every render
    selectCallbacks.current[index] = onSelect;
    function select() {
        dropdown_focus(triggerRef.current);
        onSelect && onSelect();
        dispatch({
            type: CLICK_MENU_ITEM
        });
    }
    function handleClick(event) {
        if (isRightClick(event.nativeEvent)) {
            return;
        }
        if (isLink) {
            if (disabled) {
                event.preventDefault();
            } else {
                select();
            }
        }
    }
    function handleDragStart(event) {
        // Because we don't preventDefault on mousedown for links (we need the
        // native click event), clicking and holding on a link triggers a
        // dragstart which we don't want.
        if (isLink) {
            event.preventDefault();
        }
    }
    function handleMouseDown(event) {
        if (isRightClick(event.nativeEvent)) {
            return;
        }
        if (isLink) {
            // Signal that the mouse is down so we can call the right function if the
            // user is clicking on a link.
            mouseEventStarted.current = true;
        } else {
            event.preventDefault();
        }
    }
    function handleMouseEnter(event) {
        let doc = getOwnerDocument(dropdownRef.current);
        if (!isSelected && index != null && !disabled) {
            if ((dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) && dropdownRef.current !== doc.activeElement && ownRef.current !== doc.activeElement) {
                dropdownRef.current.focus();
            }
            dispatch({
                type: SELECT_ITEM_AT_INDEX,
                payload: {
                    index
                }
            });
        }
    }
    function handleMouseLeave(event) {
        // Clear out selection when mouse over a non-dropdown-item child.
        dispatch({
            type: CLEAR_SELECTION_INDEX
        });
    }
    function handleMouseMove(event) {
        if (!readyToSelect.current) {
            let threshold = 8;
            let deltaX = Math.abs(event.clientX - mouseDownStartPosRef.current.x);
            let deltaY = Math.abs(event.clientY - mouseDownStartPosRef.current.y);
            if (deltaX > threshold || deltaY > threshold) {
                readyToSelect.current = true;
            }
        }
        if (!isSelected && index != null && !disabled) {
            dispatch({
                type: SELECT_ITEM_AT_INDEX,
                payload: {
                    index,
                    dropdownRef
                }
            });
        }
    }
    function handleFocus() {
        readyToSelect.current = true;
        if (!isSelected && index != null && !disabled) {
            dispatch({
                type: SELECT_ITEM_AT_INDEX,
                payload: {
                    index
                }
            });
        }
    }
    function handleMouseUp(event) {
        if (isRightClick(event.nativeEvent)) {
            return;
        }
        if (!readyToSelect.current) {
            readyToSelect.current = true;
            return;
        }
        if (isLink) {
            // If a mousedown event was initiated on a link item followed by a mouseup
            // event on the same link, we do nothing; a click event will come next and
            // handle selection. Otherwise, we trigger a click event.
            if (mouseEventStarted.current) {
                mouseEventStarted.current = false;
            } else if (ownRef.current) {
                ownRef.current.click();
            }
        } else {
            if (!disabled) {
                select();
            }
        }
    }
    react.useEffect(()=>{
        if (isExpanded) {
            // When the dropdown opens, wait for about half a second before enabling
            // selection. This is designed to mirror dropdown menus on macOS, where
            // opening a menu on top of a trigger would otherwise result in an
            // immediate accidental selection once the click trigger is released.
            let id = window.setTimeout(()=>{
                readyToSelect.current = true;
            }, 400);
            return ()=>{
                window.clearTimeout(id);
            };
        } else {
            // When the dropdown closes, reset readyToSelect for the next interaction.
            readyToSelect.current = false;
        }
    }, [
        isExpanded,
        readyToSelect
    ]);
    // Any time a mouseup event occurs anywhere in the document, we reset the
    // mouseEventStarted ref so we can check it again when needed.
    react.useEffect(()=>{
        let ownerDocument = getOwnerDocument(ownRef.current);
        ownerDocument.addEventListener("mouseup", listener);
        return ()=>{
            ownerDocument.removeEventListener("mouseup", listener);
        };
        function listener() {
            mouseEventStarted.current = false;
        }
    }, []);
    return {
        data: {
            disabled
        },
        props: {
            id: useItemId(index),
            tabIndex: -1,
            ...props,
            ref,
            "data-disabled": disabled ? "" : undefined,
            "data-selected": isSelected ? "" : undefined,
            "data-valuetext": valueText,
            onClick: composeEventHandlers(onClick, handleClick),
            onDragStart: composeEventHandlers(onDragStart, handleDragStart),
            onMouseDown: composeEventHandlers(onMouseDown, handleMouseDown),
            onMouseEnter: composeEventHandlers(onMouseEnter, handleMouseEnter),
            onMouseLeave: composeEventHandlers(onMouseLeave, handleMouseLeave),
            onMouseMove: composeEventHandlers(onMouseMove, handleMouseMove),
            onFocus: composeEventHandlers(onFocus, handleFocus),
            onMouseUp: composeEventHandlers(onMouseUp, handleMouseUp)
        }
    };
}
/**
 * DropdownItem
 */ const DropdownItem = /*#__PURE__*/ react.forwardRef((param, forwardedRef)=>{
    let { as: Comp = "div" , ...rest } = param;
    let { props  } = useDropdownItem({
        ...rest,
        ref: forwardedRef
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comp, {
        "data-reach-dropdown-item": "",
        ...props
    });
});
DropdownItem.displayName = "DropdownItem";
////////////////////////////////////////////////////////////////////////////////
function useDropdownItems(param) {
    let { id , onKeyDown , ref: forwardedRef , ...props } = param;
    let { dispatch , triggerRef , dropdownRef , selectCallbacks , dropdownId , state: { isExpanded , triggerId , selectionIndex , typeaheadQuery  }  } = useDropdownContext("useDropdownItems");
    let items = useDropdownDescendants();
    let ref = (0,compose_refs/* useComposedRefs */.e)(dropdownRef, forwardedRef);
    react.useEffect(()=>{
        // Respond to user char key input with typeahead
        let match = findItemFromTypeahead(items, typeaheadQuery);
        if (typeaheadQuery && match != null) {
            dispatch({
                type: SELECT_ITEM_AT_INDEX,
                payload: {
                    index: match,
                    dropdownRef
                }
            });
        }
        let timeout = window.setTimeout(()=>typeaheadQuery && dispatch({
                type: SEARCH_FOR_ITEM,
                payload: ""
            }), 1000);
        return ()=>window.clearTimeout(timeout);
    }, [
        dispatch,
        items,
        typeaheadQuery,
        dropdownRef
    ]);
    let prevItemsLength = usePrevious(items.length);
    let prevSelected = usePrevious(items[selectionIndex]);
    let prevSelectionIndex = usePrevious(selectionIndex);
    react.useEffect(()=>{
        if (selectionIndex > items.length - 1) {
            // If for some reason our selection index is larger than our possible
            // index range (let's say the last item is selected and the list
            // dynamically updates), we need to select the last item in the list.
            dispatch({
                type: SELECT_ITEM_AT_INDEX,
                payload: {
                    index: items.length - 1,
                    dropdownRef
                }
            });
        } else if (// Checks if
        //  - item length has changed
        //  - selection index has not changed BUT selected item has changed
        //
        // This prevents any dynamic adding/removing of items from actually
        // changing a user's expected selection.
        prevItemsLength !== items.length && selectionIndex > -1 && prevSelected && prevSelectionIndex === selectionIndex && items[selectionIndex] !== prevSelected) {
            dispatch({
                type: SELECT_ITEM_AT_INDEX,
                payload: {
                    index: items.findIndex((i)=>{
                        return i.key === (prevSelected === null || prevSelected === void 0 ? void 0 : prevSelected.key);
                    }),
                    dropdownRef
                }
            });
        }
    }, [
        dropdownRef,
        dispatch,
        items,
        prevItemsLength,
        prevSelected,
        prevSelectionIndex,
        selectionIndex
    ]);
    let handleKeyDown = composeEventHandlers(function handleKeyDown(event) {
        let { key  } = event;
        if (!isExpanded) {
            return;
        }
        switch(key){
            case "Enter":
            case " ":
                let selected = items.find((item)=>item.index === selectionIndex);
                // For links, the Enter key will trigger a click by default, but for
                // consistent behavior across items we'll trigger a click when the
                // spacebar is pressed.
                if (selected && !selected.disabled) {
                    event.preventDefault();
                    if (selected.isLink && selected.element) {
                        selected.element.click();
                    } else {
                        // Focus the button first by default when an item is selected.
                        // We fire the onSelect callback next so the app can manage
                        // focus if needed.
                        dropdown_focus(triggerRef.current);
                        selectCallbacks.current[selected.index] && selectCallbacks.current[selected.index]();
                        dispatch({
                            type: CLICK_MENU_ITEM
                        });
                    }
                }
                break;
            case "Escape":
                dropdown_focus(triggerRef.current);
                dispatch({
                    type: CLOSE_MENU
                });
                break;
            case "Tab":
                // prevent leaving
                event.preventDefault();
                break;
            default:
                // Check if a user is typing some char keys and respond by setting
                // the query state.
                if ((0,type_check/* isString */.HD)(key) && key.length === 1) {
                    let query = typeaheadQuery + key.toLowerCase();
                    dispatch({
                        type: SEARCH_FOR_ITEM,
                        payload: query
                    });
                }
                break;
        }
    }, useDescendantKeyDown(DropdownDescendantContext, {
        currentIndex: selectionIndex,
        orientation: "vertical",
        rotate: false,
        filter: (item)=>!item.disabled,
        callback: (index)=>{
            dispatch({
                type: SELECT_ITEM_AT_INDEX,
                payload: {
                    index,
                    dropdownRef
                }
            });
        },
        key: "index"
    }));
    return {
        data: {
            activeDescendant: useItemId(selectionIndex) || undefined,
            triggerId
        },
        props: {
            tabIndex: -1,
            ...props,
            ref,
            id: dropdownId,
            onKeyDown: composeEventHandlers(onKeyDown, handleKeyDown)
        }
    };
}
/**
 * DropdownItem
 */ const DropdownItems = /*#__PURE__*/ react.forwardRef((param, forwardedRef)=>{
    let { as: Comp = "div" , ...rest } = param;
    let { props  } = useDropdownItems({
        ...rest,
        ref: forwardedRef
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comp, {
        "data-reach-dropdown-items": "",
        ...props
    });
});
DropdownItems.displayName = "DropdownItems";
////////////////////////////////////////////////////////////////////////////////
function useDropdownPopover() {
    let { triggerRef , triggerClickedRef , dispatch , dropdownRef , popoverRef , state: { isExpanded  }  } = useDropdownContext("useDropdownPopover");
    react.useEffect(()=>{
        if (!isExpanded) {
            return;
        }
        let ownerDocument = getOwnerDocument(popoverRef.current);
        function listener(event) {
            if (triggerClickedRef.current) {
                triggerClickedRef.current = false;
            } else if (!popoverContainsEventTarget(popoverRef.current, event.target)) {
                // We on want to close only if focus rests outside the dropdown
                dispatch({
                    type: CLOSE_MENU
                });
            }
        }
        ownerDocument.addEventListener("mousedown", listener);
        // see https://github.com/reach/reach-ui/pull/700#discussion_r530369265
        // ownerDocument.addEventListener("touchstart", listener);
        return ()=>{
            ownerDocument.removeEventListener("mousedown", listener);
        // ownerDocument.removeEventListener("touchstart", listener);
        };
    }, [
        triggerClickedRef,
        triggerRef,
        dispatch,
        dropdownRef,
        popoverRef,
        isExpanded
    ]);
}
////////////////////////////////////////////////////////////////////////////////
/**
 * When a user's typed input matches the string displayed in an item, it is
 * expected that the matching item is selected. This is our matching function.
 */ function findItemFromTypeahead(items) {
    let string = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (!string) {
        return null;
    }
    let found = items.find((item)=>{
        var _item_element, _item_element_dataset, _item_element_dataset_valuetext;
        return item.disabled ? false : (_item_element = item.element) === null || _item_element === void 0 ? void 0 : (_item_element_dataset = _item_element.dataset) === null || _item_element_dataset === void 0 ? void 0 : (_item_element_dataset_valuetext = _item_element_dataset.valuetext) === null || _item_element_dataset_valuetext === void 0 ? void 0 : _item_element_dataset_valuetext.toLowerCase().startsWith(string);
    });
    return found ? items.indexOf(found) : null;
}
function useItemId(index) {
    let { dropdownId  } = useDropdownContext("useItemId");
    return index != null && index > -1 ? makeId("option-".concat(index), dropdownId) : undefined;
}
function dropdown_focus(element) {
    element && element.focus();
}
function popoverContainsEventTarget(popover, target) {
    return !!(popover && popover.contains(target));
}
function reducer(state) {
    let action = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    switch(action.type){
        case CLICK_MENU_ITEM:
            return {
                ...state,
                isExpanded: false,
                selectionIndex: -1
            };
        case CLOSE_MENU:
            return {
                ...state,
                isExpanded: false,
                selectionIndex: -1
            };
        case OPEN_MENU_AT_FIRST_ITEM:
            return {
                ...state,
                isExpanded: true,
                selectionIndex: 0
            };
        case OPEN_MENU_AT_INDEX:
            return {
                ...state,
                isExpanded: true,
                selectionIndex: action.payload.index
            };
        case OPEN_MENU_CLEARED:
            return {
                ...state,
                isExpanded: true,
                selectionIndex: -1
            };
        case SELECT_ITEM_AT_INDEX:
            {
                let { dropdownRef ={
                    current: null
                }  } = action.payload;
                if (action.payload.index >= 0 && action.payload.index !== state.selectionIndex) {
                    if (dropdownRef.current) {
                        let doc = getOwnerDocument(dropdownRef.current);
                        if (dropdownRef.current !== (doc === null || doc === void 0 ? void 0 : doc.activeElement)) {
                            dropdownRef.current.focus();
                        }
                    }
                    return {
                        ...state,
                        selectionIndex: action.payload.max != null ? Math.min(Math.max(action.payload.index, 0), action.payload.max) : Math.max(action.payload.index, 0)
                    };
                }
                return state;
            }
        case CLEAR_SELECTION_INDEX:
            return {
                ...state,
                selectionIndex: -1
            };
        case SET_BUTTON_ID:
            return {
                ...state,
                triggerId: action.payload
            };
        case SEARCH_FOR_ITEM:
            if (typeof action.payload !== "undefined") {
                return {
                    ...state,
                    typeaheadQuery: action.payload
                };
            }
            return state;
        default:
            return state;
    }
}
function useDropdownDescendants() {
    return useDescendants(DropdownDescendantContext);
}



/***/ }),

/***/ 35625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uk": function() { return /* binding */ MenuLink; },
/* harmony export */   "j2": function() { return /* binding */ MenuButton; },
/* harmony export */   "sN": function() { return /* binding */ MenuItem; },
/* harmony export */   "sd": function() { return /* binding */ MenuItems; },
/* harmony export */   "v2": function() { return /* binding */ Menu; }
/* harmony export */ });
/* unused harmony export useMenuButtonContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59864);
/* harmony import */ var shared_lib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62046);
/* harmony import */ var _dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92400);
/**
 * Welcome to @reach/menu-button!
 *
 * An accessible dropdown menu for the common dropdown menu button design
 * pattern.
 *
 * @see Docs     https://reach.tech/menu-button
 * @see Source   https://github.com/reach/reach-ui/tree/main/packages/menu-button
 * @see WAI-ARIA https://www.w3.org/TR/wai-aria-practices-1.2/#menubutton
 *
 * TODO: Fix flash when opening a menu button on a screen with another open menu
 */ 




const __DEV__ = "production" === "development";
////////////////////////////////////////////////////////////////////////////////
/**
 * Menu
 *
 * The wrapper component for the other components. No DOM element is rendered.
 *
 * @see Docs https://reach.tech/menu-button#menu
 */ const Menu = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, forwardedRef)=>{
    let { as: Comp = react__WEBPACK_IMPORTED_MODULE_1__.Fragment , id , children , placement , ...rest } = param;
    let parentIsFragment = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(()=>{
        try {
            // To test if the component renders a fragment we need to actually
            // render it, but this may throw an error since we can't predict what is
            // actually provided. There's technically a small chance that this could
            // get it wrong but I don't think it's too likely in practice.
            return (0,react_is__WEBPACK_IMPORTED_MODULE_2__.isFragment)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, {}));
        } catch (err) {
            return false;
        }
    }, [
        Comp
    ]);
    let props = parentIsFragment ? {} : {
        ref: forwardedRef,
        id,
        "data-reach-menu": "",
        ...rest
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, {
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dropdown__WEBPACK_IMPORTED_MODULE_3__/* .DropdownProvider */ .KG, {
            id: id,
            placement: placement,
            children: children
        })
    });
});
Menu.displayName = "Menu";
////////////////////////////////////////////////////////////////////////////////
/**
 * MenuButton
 *
 * Wraps a DOM `button` that toggles the opening and closing of the dropdown
 * menu. Must be rendered inside of a `<Menu>`.
 *
 * @see Docs https://reach.tech/menu-button#menubutton
 */ const MenuButton = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, forwardedRef)=>{
    let { as: Comp = "button" , ...rest } = param;
    let { data: { isExpanded , controls  } , props  } = (0,_dropdown__WEBPACK_IMPORTED_MODULE_3__/* .useDropdownTrigger */ .MK)({
        ...rest,
        ref: forwardedRef
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, {
        // When the menu is displayed, the element with role `button` has
        // `aria-expanded` set to `true`. When the menu is hidden, it is
        // recommended that `aria-expanded` is not present.
        // https://www.w3.org/TR/wai-aria-practices-1.2/#menubutton
        "aria-expanded": isExpanded ? true : undefined,
        // The element with role `button` has `aria-haspopup` set to either
        // `"menu"` or `true`.
        // https://www.w3.org/TR/wai-aria-practices-1.2/#menubutton
        "aria-haspopup": true,
        // Optionally, the element with role `button` has a value specified for
        // `aria-controls` that refers to the element with role `menu`.
        // https://www.w3.org/TR/wai-aria-practices-1.2/#menubutton
        "aria-controls": controls,
        ...props,
        "data-reach-menu-button": ""
    });
});
MenuButton.displayName = "MenuButton";
////////////////////////////////////////////////////////////////////////////////
/**
 * MenuItemImpl
 *
 * MenuItem and MenuLink share most of the same functionality captured here.
 */ const MenuItemImpl = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, forwardedRef)=>{
    let { as: Comp = "div" , ...rest } = param;
    let { data: { disabled  } , props  } = (0,_dropdown__WEBPACK_IMPORTED_MODULE_3__/* .useDropdownItem */ .FG)({
        ...rest,
        ref: forwardedRef
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, {
        role: "menuitem",
        ...props,
        "aria-disabled": disabled || undefined,
        "data-reach-menu-item": ""
    });
});
MenuItemImpl.displayName = "MenuItemImpl";
////////////////////////////////////////////////////////////////////////////////
/**
 * MenuItem
 *
 * Handles menu selection. Must be a direct child of a `<MenuList>`.
 *
 * @see Docs https://reach.tech/menu-button#menuitem
 */ const MenuItem = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, forwardedRef)=>{
    let { as ="div" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuItemImpl, {
        ...props,
        ref: forwardedRef,
        as: as
    });
});
MenuItem.displayName = "MenuItem";
////////////////////////////////////////////////////////////////////////////////
/**
 * MenuItems
 *
 * A low-level wrapper for menu items. Compose it with `MenuPopover` for more
 * control over the nested components and their rendered DOM nodes, or if you
 * need to nest arbitrary components between the outer wrapper and your list.
 *
 * @see Docs https://reach.tech/menu-button#menuitems
 */ const MenuItems = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, forwardedRef)=>{
    let { as: Comp = "div" , ...rest } = param;
    let { data: { activeDescendant , triggerId  } , props  } = (0,_dropdown__WEBPACK_IMPORTED_MODULE_3__/* .useDropdownItems */ .eV)({
        ...rest,
        ref: forwardedRef
    });
    return(// TODO: Should probably file a but in jsx-a11y, but this is correct
    // according to https://www.w3.org/TR/wai-aria-practices-1.2/examples/menu-button/menu-button-actions-active-descendant.html
    // eslint-disable-next-line jsx-a11y/aria-activedescendant-has-tabindex
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, {
        // Refers to the descendant menuitem element that is visually indicated
        // as focused.
        // https://www.w3.org/TR/wai-aria-practices-1.2/examples/menu-button/menu-button-actions-active-descendant.html
        "aria-activedescendant": activeDescendant,
        // Refers to the element that contains the accessible name for the
        // `menu`. The menu is labeled by the menu button.
        // https://www.w3.org/TR/wai-aria-practices-1.2/examples/menu-button/menu-button-actions-active-descendant.html
        "aria-labelledby": triggerId || undefined,
        // The element that contains the menu items displayed by activating the
        // button has role menu.
        // https://www.w3.org/TR/wai-aria-practices-1.2/#menubutton
        role: "menu",
        ...props,
        "data-reach-menu-items": ""
    }));
});
MenuItems.displayName = "MenuItems";
////////////////////////////////////////////////////////////////////////////////
/**
 * MenuLink
 *
 * Handles linking to a different page in the menu. By default it renders `<a>`,
 * but also accepts any other kind of Link as long as the `Link` uses the
 * `React.forwardRef` API.
 *
 * Must be a direct child of a `<MenuList>`.
 *
 * @see Docs https://reach.tech/menu-button#menulink
 */ const MenuLink = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, forwardedRef)=>{
    let { as ="a" , // @ts-ignore
    component , onSelect , ...props } = param;
    if (__DEV__) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        react__WEBPACK_IMPORTED_MODULE_1__.useEffect(()=>{
            if (component) {
                console.warn("[@reach/menu-button]: Please use the `as` prop instead of `component`");
            }
        }, [
            component
        ]);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuItemImpl, {
        ...props,
        ref: forwardedRef,
        "data-reach-menu-link": "",
        as: as,
        isLink: true,
        onSelect: onSelect || shared_lib__WEBPACK_IMPORTED_MODULE_4__/* .noop */ .Z
    });
});
MenuLink.displayName = "MenuLink";
////////////////////////////////////////////////////////////////////////////////
/**
 * A hook that exposes data for a given `Menu` component to its descendants.
 *
 * @see Docs https://reach.tech/menu-button#usemenubuttoncontext
 */ function useMenuButtonContext() {
    let { state: { isExpanded  }  } = useDropdownContext("useMenuButtonContext");
    return React.useMemo(()=>({
            isExpanded
        }), [
        isExpanded
    ]);
}



/***/ }),

/***/ 92422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ MenuButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_ui_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76780);
/* harmony import */ var _lib_menu_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35625);




const MenuButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lib_menu_button__WEBPACK_IMPORTED_MODULE_2__/* .MenuButton */ .j2, {
        as: shared_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z,
        ...props,
        ref: ref
    });
});
MenuButton.defaultProps = {};


/***/ }),

/***/ 8581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ MenuContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lib_menu_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35625);
/* harmony import */ var _menu_container_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66153);
/* harmony import */ var _menu_container_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_menu_container_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const MenuContainer = (props)=>{
    // const [referenceElement, setReferenceElement] = React.useState<any>(null);
    // const [popperElement, setPopperElement] = React.useState<HTMLDivElement | null>(null);
    // const popper = usePopper(referenceElement, popperElement);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lib_menu_button__WEBPACK_IMPORTED_MODULE_3__/* .Menu */ .v2, {
        placement: props.placement,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_menu_container_module_scss__WEBPACK_IMPORTED_MODULE_4___default().menu_container), props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
MenuContainer.defaultProps = {
    placement: "bottom-start"
};


/***/ }),

/***/ 38234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ MenuItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lib_menu_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35625);
/* harmony import */ var _menu_item_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9993);
/* harmony import */ var _menu_item_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_menu_item_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const MenuItem = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_lib_menu_button__WEBPACK_IMPORTED_MODULE_3__/* .MenuItem */ .sN, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_menu_item_module_scss__WEBPACK_IMPORTED_MODULE_4___default().menu_item), props.type === "error" && (_menu_item_module_scss__WEBPACK_IMPORTED_MODULE_4___default().error), props.className),
        style: props.style,
        id: props.htmlId,
        disabled: props.disabled,
        onSelect: ()=>{
            var _props_onClick;
            return (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props);
        },
        children: [
            props.prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_menu_item_module_scss__WEBPACK_IMPORTED_MODULE_4___default().prefix),
                children: props.prefix
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: props.children
            }),
            props.suffix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_menu_item_module_scss__WEBPACK_IMPORTED_MODULE_4___default().suffix),
                children: props.suffix
            })
        ]
    });
};
MenuItem.defaultProps = {};


/***/ }),

/***/ 78024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ Menu; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95237);
/* harmony import */ var shared_lib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53938);
/* harmony import */ var shared_lib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41176);
/* harmony import */ var shared_ui_drawer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6547);
/* harmony import */ var shared_ui_menu_lib_portal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45222);
/* harmony import */ var _lib_dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92400);
/* harmony import */ var _lib_menu_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35625);
/* harmony import */ var _menu_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63398);
/* harmony import */ var _menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_menu_module_scss__WEBPACK_IMPORTED_MODULE_8__);










const Menu = (param)=>{
    let { width , minWidth , children , arrow , ...props } = param;
    let { popoverRef , state: { isExpanded  } , placement , referenceElement , dispatch  } = (0,_lib_dropdown__WEBPACK_IMPORTED_MODULE_3__/* .useDropdownContext */ .tv)("Menu");
    const [popperElement, setPopperElement] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [arrowElement, setArrowElement] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const modifiers = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (arrow) {
            return [
                {
                    name: "arrow",
                    options: {
                        element: arrowElement
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            11
                        ]
                    }
                }
            ];
        }
        return [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        4
                    ]
                }
            }
        ];
    }, [
        arrowElement,
        arrow
    ]);
    const popper = (0,react_popper__WEBPACK_IMPORTED_MODULE_4__/* .usePopper */ .D)(referenceElement, popperElement, {
        placement,
        modifiers
    });
    const ref = (0,shared_lib__WEBPACK_IMPORTED_MODULE_5__/* .useComposedRefs */ .e)(setPopperElement, popoverRef);
    (0,_lib_dropdown__WEBPACK_IMPORTED_MODULE_3__/* .useDropdownPopover */ .ED)();
    const mobile = (0,shared_lib__WEBPACK_IMPORTED_MODULE_6__/* .useHandleResize */ .s)() <= 600;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui_menu_lib_portal__WEBPACK_IMPORTED_MODULE_7__/* .Portal */ .h, {
        children: isExpanded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            ref: ref,
            className: (_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
            style: {
                width,
                minWidth,
                ...popper.styles.popper
            },
            ...popper.attributes.popper,
            children: [
                arrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: setArrowElement,
                    className: (_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrow),
                    style: popper.styles.arrow,
                    ...popper.attributes.arrow
                }),
                mobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui_drawer__WEBPACK_IMPORTED_MODULE_9__/* .Drawer */ .d, {
                    show: true,
                    onDismiss: ()=>dispatch({
                            type: "CLOSE_MENU"
                        }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lib_menu_button__WEBPACK_IMPORTED_MODULE_10__/* .MenuItems */ .sd, {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().menu), (_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().no_border), props.className),
                        children: children
                    })
                }),
                !mobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lib_menu_button__WEBPACK_IMPORTED_MODULE_10__/* .MenuItems */ .sd, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_menu_module_scss__WEBPACK_IMPORTED_MODULE_8___default().menu), props.className),
                    children: children
                })
            ]
        })
    });
};
Menu.defaultProps = {
    arrow: true
};


/***/ }),

/***/ 91028:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"drawer":"drawer_drawer__2fOIE","inner":"drawer_inner__mMHFw"};

/***/ }),

/***/ 5915:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__3nfmj","with_prefix":"input_with_prefix__PJaMW","no_prefix_styling":"input_no_prefix_styling__r1I0o","with_suffix":"input_with_suffix__3pqbu","no_suffix_styling":"input_no_suffix_styling__IB8lb","small":"input_small__Gn8oO","medium":"input_medium__Fe7P_","large":"input_large__gBfuS","prefix":"input_prefix__OaS5K","suffix":"input_suffix__5zLuo","no_styling":"input_no_styling___DHAx","focus":"input_focus__dMs8Y","readonly":"input_readonly__EfGq8"};

/***/ }),

/***/ 66153:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu_item":"menu-item_menu_item__9rnmi","error":"menu-item_error__4Xoco","prefix":"menu-item_prefix__iOVXr","suffix":"menu-item_suffix__Q2_3_"};

/***/ }),

/***/ 63398:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__HH5nV","no_border":"menu_no_border__WKhWp","wrapper":"menu_wrapper__ebSCw","arrow":"menu_arrow__aYhG2"};

/***/ })

}]);